import useCurrentPlan from "../../../../hooks/useCurrentPlan";
import ScenarioDefinition from "./scenarioDefinition";
import CommercialPlanGrid from "./commercialPlanGrid";
import SimulatorSummary from "./simulatorSummary";
import VolumeDriversSummary from "./volumeDriversSummary";

const CommercialPlanPanel: React.FC = () => {
    const { currentPlan } = useCurrentPlan();

    return (
        <div className="d-flex flex-column gap-4 min-w-0 w-100">
            <ScenarioDefinition />
            <SimulatorSummary planData={currentPlan} />
            <VolumeDriversSummary isLoading={currentPlan == null} />
            <CommercialPlanGrid planData={currentPlan} />
        </div>
    );
};

export default CommercialPlanPanel;
